import { MapTo } from '@adobe/aem-react-editable-components';
import spreadModelProps from 'helpers/spreadModelProps';
import DeeplinkContainer from './DeeplinkContainer';

export default MapTo('aweb/components/content/deeplink')(spreadModelProps(DeeplinkContainer));
